<div class="modal-header">
    <h6 class="modal-title pull-left"> {{updateId==''?'Add':'Edit' }} About Us</h6>
    <button type="button" class="close btn" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <div class="row">
        <div class="col-md-12 col-sm-12">
            <div class="form-group">
                <label for="ID">Role</label>
                <ng-select class="selectpicker selecterchart" [(ngModel)]="addUserObj.user_role"
                    (ngModelChange)="onRoleChange($event)">
                    <ng-option value="" disabled="true">Select Role</ng-option>
                    <ng-option value="1">Speaker </ng-option>
                    <ng-option value="2">Delegate </ng-option>
                    <ng-option value="3">AFGG</ng-option>
                </ng-select>
            </div>
        </div>
       
        
        <div class="col-md-12 col-sm-12">
            <div class="form-group">
                <label for="qustion">About Us</label>
                <!-- <textarea class="form-control" rows="4" placeholder="About Us"
                    [(ngModel)]="addUserObj.about_us"></textarea> -->
                    <angular-editor id="editor1" placeholder="About Us" [(ngModel)]="addUserObj.about_us" [config]="config"></angular-editor>
            </div>
        </div>

    </div>
   

</div>
<div class="modal-footer">
    <button type="button" class="btn btn-danger btn-sm" (click)="activeModal.dismiss()">Cancel</button>&nbsp;
    <button type="button" class="btn btn-primary btn-sm" (click)="save()">Save</button>
</div>